export default {
  priceTemplateString: '%price%',
  bikePrice: 2500
};
